import { OwcTypography } from "@one/react";
const InlineTypography = ({ children }) => {
  return (
    <OwcTypography variant="button" style={{ display: 'inline-block' }} element="span">
      {children}
    </OwcTypography>
  )
}

export default InlineTypography
